/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaskPriorityEnum = {
    Normal: 'NORMAL',
    Urgent: 'URGENT',
    VeryUrgent: 'VERY_URGENT'
} as const;
export type TaskPriorityEnum = typeof TaskPriorityEnum[keyof typeof TaskPriorityEnum];

